import type { TabContent } from '../PageConfigProvider/page-reducer';

export interface LLMTabContentForApi {
  items: Array<{
    title: string | null;
    position: { x: number; y: number; width: number; height: number };
    plot?: {
      chartType: string;
      defaultMetricOptions: string[];
      secondaryDimension?: string;
      plotFilters?: Array<{ type: string; value: number }>;
      dimensionSource?: {
        type: 'PRIMARY_DIMENSION' | 'TOP_SEGMENTS';
        segment?: string;
      };
      color?: string;
      showDataLabels?: boolean;
      showZebraStripe?: boolean;
    };
  }>;
  grid: { rows: number; columns: number };
  secondaryFilters: { id: string }[];
}

export function convertTabContentToLLM(
  tabContent: TabContent
): LLMTabContentForApi {
  return {
    items: tabContent.items.map((item) => ({
      title: item.title,
      position: item.position,
      plot: item.plot
        ? {
            chartType: item.plot.chartType ?? '',
            defaultMetricOptions: item.plot.defaultMetricOptions ?? [],
            secondaryDimension: item.plot.secondaryDimension,
            plotFilters: item.plot.plotFilters?.map((f) => ({
              type: f.type,
              value: f.value,
            })),
            dimensionSource: (() => {
              if (!item.plot.dimensionSource) {
                return undefined;
              }
              if (item.plot.dimensionSource === 'primary') {
                return {
                  type: 'PRIMARY_DIMENSION' as const,
                };
              }
              return {
                type: 'TOP_SEGMENTS' as const,
                segment: item.plot.dimensionSource,
              };
            })(),
            ...(item.plot.color && { color: item.plot.color }),
            ...(item.plot.showDataLabels !== undefined && {
              showDataLabels: item.plot.showDataLabels,
            }),
            ...(item.plot.showZebraStripe !== undefined && {
              showZebraStripe: item.plot.showZebraStripe,
            }),
          }
        : undefined,
    })),
    grid: tabContent.grid,
    secondaryFilters: tabContent.secondaryFilters.map((f) => ({ id: f.id })),
  };
}
